import { render } from "./appNav.vue?vue&type=template&id=09d5de0e&scoped=true"
const script = {}

import "./appNav.vue?vue&type=style&index=0&id=09d5de0e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d5de0e"]])

export default __exports__